<script>
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import {
  CollectionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-collection-card/collection-card-element-mixin";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "CollectionCoverImage",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayName: "Collection Cover Image",
    displayIcon: "image",
    elementType: "element",
    elementGroup: "collectionElements",
  },
  mixins: [CollectionCardElementMixin, FallbackImageElementMixin],
  computed: {
    imageHref() {
      return useGeneralStore().getRelativeHref(`/collection-items/${this.entity.collectionId}`);
    },
    imageSrc() {
      return this.entity.coverImageUrl;
    },
  },
};
</script>
